import api from '@/api';

import { API_BASE_URL } from '..';
import {
  CreateProfileRequest,
  UpdateProfileRequest,
  Profile,
  ProfileReduced,
  DuplicateProfile,
} from './Profiles.types';

const CONTROLLER_URL = `${API_BASE_URL}/profiles`;

export async function listProfiles() {
  const result = (await api.get(`${CONTROLLER_URL}/matrix`, null)) as unknown;

  return result as Profile[];
}

export async function listProfilesReduced() {
  const result = (await api.get(
    `${CONTROLLER_URL}/matrix/reduced`,
    null,
  )) as unknown;

  return result as ProfileReduced[];
}

export async function getProfile(id: number) {
  const result = (await api.get(`${CONTROLLER_URL}/${id}`, null)) as unknown;

  return result as Profile;
}

export async function getProfileReduced(id: number) {
  const result = (await api.get(
    `${CONTROLLER_URL}/${id}/reduced`,
    null,
  )) as unknown;

  return result as ProfileReduced;
}

export async function createProfile(obj: CreateProfileRequest) {
  const result = (await api.post(`${CONTROLLER_URL}`, obj, null)) as unknown;

  return result as Profile;
}

export async function duplicateProfile(obj: DuplicateProfile) {
  const result = (await api.post(
    `${CONTROLLER_URL}/duplicate`,
    obj,
    null,
  )) as unknown;

  return result as Profile;
}

export async function updateProfile(obj: UpdateProfileRequest) {
  const result = (await api.put(`${CONTROLLER_URL}`, obj, null)) as unknown;

  return result as Profile;
}

export async function removeProfile(id: number) {
  const result = (await api.remove(
    `${CONTROLLER_URL}/${id}`,
    {},
    null,
  )) as unknown;

  return result as void;
}
